<script setup lang="ts">

import { AppText } from '@shared/ui/typography'
import { ModalDefault } from '@shared/ui/modals'
import { NativeSelect } from '@shared/ui/fields'
import { BtnPrimary, BtnSecondary } from '@shared/ui/buttons'

import { useModalKidAddDiscipline } from '../../model/modal-kid-add-discipline.hook'

defineOptions({
  name: 'ModalKidAddDiscipline',
})

const {
  refIsOpen,
  refIsLoading,
  refTitle,
  refCode,
  disciplineOptions,
  isSubmitDisabled,
  setCode,
  closeModal,
  submit,
} = useModalKidAddDiscipline()
</script>

<template>
  <ModalDefault
    :show="refIsOpen"
    :loading="refIsLoading"
    :title="refTitle"
    is-close-button
    @click:overlay="closeModal"
    @click:close="closeModal"
  >
    <div class="modal-kid-add-discipline">
      <AppText name="body1">
        Are you sure you want to add discipline this kid?
      </AppText>
      <NativeSelect
        name="discipline_discipline"
        label="Discipline"
        placeholder="Select here"
        placeholder-enabled
        :value="refCode"
        :options="disciplineOptions"
        @change="setCode"
      />
    </div>

    <template #controls>
      <BtnPrimary
        text="Add discipline"
        color="emerald"
        :disabled="isSubmitDisabled"
        @click="submit"
      />
      <BtnSecondary
        text="Close"
        :disabled="refIsLoading"
        @click="closeModal"
      />
    </template>
  </ModalDefault>
</template>

<style scoped lang="scss" src="./ModalKidAddDiscipline.scss" />
